import ContactUs from "@/components/ContactUs";
import rfStore from "@/utils/rfStore";
import { createContext, useCallback, useContext, useEffect, useState } from "react";

interface State {
	onShowContactUs?: () => void;
	onHiddenContactUs?: () => void;
}
const ContactUsContext = createContext<State>({});

export const ContactUsContextProvider: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	const [shouldRenderContactUs, setShouldRenderContactUs] = useState(false);
	const handleShowContactUs = useCallback(() => {
		window?.$chatwoot?.toggle("open");
	}, []);

	const handleHiddenContactUs = useCallback(() => {
		window?.$chatwoot?.toggle("close");
	}, []);
	useEffect(() => {
		const isinApp = !!rfStore.getRFState()?.model;
		setShouldRenderContactUs(!isinApp);
	}, []);
	return (
		<ContactUsContext.Provider
			value={{
				onShowContactUs: handleShowContactUs,
				onHiddenContactUs: handleHiddenContactUs,
			}}
		>
			{children}
			{shouldRenderContactUs && <ContactUs />}
		</ContactUsContext.Provider>
	);
};

export const useContactUsContext = () => useContext(ContactUsContext);

export default ContactUsContext;
